export default class ProjectsFilter { 
  filter;
  filterItems;
  list;
  constructor(filter, list) {
    this.filter = filter;
    this.filterItems = this.filter.querySelectorAll('li > a');
    this.list = list;

    this.bindListeners();
  }

  bindListeners() {
    for (let filter of this.filterItems) { 
      filter.addEventListener('click', this.doFilter.bind(this));
    }
  }

  activateFilterItem(item) { 
    item.classList.add('active');
  }

  removeActiveFilterItem() { 
    this.filter.querySelector('li > a.active').classList.remove('active');
  }

  doFilter(ev) {
    if (!ev.currentTarget.classList.contains('active')) {
      let slug = ev.currentTarget.getAttribute('data-filter');
      let lang = this.list.getAttribute('data-lang') ? this.list.getAttribute('data-lang'): 'es';
      this.removeActiveFilterItem();
      this.activateFilterItem(ev.currentTarget);
      this.list.classList.add('filtering');
      fetch('https://www.nerefalagan.com/wp-json/nere-falagan/v1/project-filter', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({
          slug: slug,
          lang: lang
        })
      })
      .then(response => {
        this.list.classList.remove('filtering');
        return response.json();
      })
      .then(response => {
        if (JSON.parse(response) != '') {
          this.list.innerHTML = JSON.parse(response);
        }
        else {
          this.list.innerHTML = '<p class="alert">No hay resultados</p>';
        }
      });
    }
  }
}



// WEBPACK FOOTER //
// ./ui/assets/js/ProjectsFilter/ProjectsFilter.js